<template>
	<section class="content">
		<div class="card">
			<div class="overlay" v-if="loading"><h1 style="font-size:40px;">Sedang diproses <i class="fas fa-sync-alt fa-spin"></i></h1></div>
			<div class="card-body">
				<div class="row mb-3 justify-content-end" style="row-gap: .5rem;">
					<div class="col-auto col-sm-auto mr-0 pr-0">
						<label class="control-label my-2 ml-2">Per</label>
					</div>
					<div class="col-12 col-sm-auto">
						<div class="input-group">
							<datepicker v-model="filter.dt2" class="form-control datepicker border-right-0" :options="{ orientation: 'bottom', format: 'dd/mm/yyyy', autoclose: true }" />
							<div class="input-group-append">
								<div class="input-group-text rounded-right d-flex align-items-center border-left-0 pl-1 bg-white">
									<i class="fi fi-rr-calendar d-flex"></i>
								</div>
							</div>
						</div>
					</div>
					<div class="col col-sm-auto mr-auto">
						<select class="form-control" required v-model="filter.tipe_rekan" @change="dataTable.api().ajax.reload()">
							<option :value="null" selected disabled hidden>Tipe Rekan</option>
							<option v-for="tipe in listTipe" v-bind:key="tipe.id" v-bind:value="tipe.id">
								{{ tipe.label }}
							</option>
						</select>
					</div>
					<div class="col col-sm-auto text-right">
						<div class="btn-group" ref="toolbar">
							<button type="button" data-action="read" class="btn btn-primary border-right-0" v-if="false">
								<i class="fi fi-rr-refresh d-flex"></i>
							</button>
							<button type="button" :disabled="loading" v-on:click="downloadXlsx" data-action="export-xlsx" class="btn btn-primary">
								Download Data
							</button>
						</div>
					</div>
				</div>

				<table class="table table-hover row-border" ref="tableRiwayatRekonsiliasi" id="tableRiwayatRekonsiliasi">
					<thead>
						<tr>
							<th>ID Rekan</th>
							<th>Tipe Rekan</th>
							<th>Nama Rekan</th>
							<th>Sisa Hutang</th>
							<th>Aksi</th>
						</tr>
					</thead>
					<tbody @click="handleClick">
					</tbody>
				</table>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { auth, authFetch, createTable, formatRupiah } from "@/libs/hxcore";
import $ from "jquery";
import moment from "moment";
import Swal from "sweetalert2";
import "vue-select/dist/vue-select.css";
import datepicker from "@/components/Datepicker";
import "icheck-material";

export default {
	name: "Rekanan",
	data() {
		return {
			listTipe: [
				{
					id: '1',
					label: 'Kurir'
				},
				{
					id: '0',
					label: 'Internal'
				},
				{
					id: '2',
					label: 'Eksternal'
				}
			],
			showTipe: [
				'Internal',
				'Kurir',
				'Eksternal'
			],
			loading: false,
			errors: [],
			method: "",
			minDate: '1970-01-01',
			filter: {
				dt2: moment().format('DD/MM/YYYY'),
				tipe_rekan: null
			}
		};
	},
	components: {
        datepicker
	},
	created() {
		authFetch("/report/hutang/cutoff")
		.then((res) => {
			if (res.status === 201) {} else if (res.status === 400) {}
			return res.json();
		})
		.then((js) => {
			if (js.success) {
				this.minDate = js.data;
			} else {
				this.customSwal.fire({
					icon: "error",
					title: "Gagal",
					text: js.message,
					confirmButtonText: "OK"
				});
			}
		});
	},
	methods: {
		getImage(file) {
			return require(`../assets/img/${file}.svg`);
		},
		handleClick: async function(e) {
			if (e.target.dataset.action == "show") {
				let route = this.$router.resolve({
					path: "/hutang-usaha/monitoring/" + e.target.dataset.id
				});
				window.open(route.href,"_blank");
			}
		},
		downloadXlsx: function (e) {
			var table = $('#tableRiwayatRekonsiliasi').DataTable();
			var length = table.page.info().recordsTotal;

			if (length > 20000) {
				Swal.fire("Proses gagal", `Maksimal data Request sebanyak kurang lebih 20.000 data.`, "error");
				return false;
			}

			var filter = JSON.parse(JSON.stringify(this.filter));
				filter.dt2 = moment(this.filter.dt2, 'DD/MM/YYYY').format('YYYY-MM-DD');
				filter.keyword = $("input[name=q]").val();
				filter.category = $("select[name=category]").val();

			var data = Object.keys(filter)
				.map(
					(key) =>
					encodeURIComponent(key) + "=" + (filter[key] === false ? 0 : encodeURIComponent(filter[key]))
				)
				.join("&");

			this.loading = true;

			authFetch("/report/hutang/monitoring_excell", {
				method: "POST",
				body: data,
			})
			.then((response) => {
				if (response.status === 201) {
				} else if (response.status === 400) {
				} else if (response.status === 500){
					Swal.fire("Timeout!", ``, "error");
					return false;
				}

				return response.blob();
			})
			.then((blob) => {
				this.loading = false;
				var url = window.URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = url;
				a.download = "Monitoring Hutang Usaha.xlsx";
				document.body.appendChild(a);
				a.click();
				a.remove();
			});
		}
	},
	watch: {
		filter: {
			handler(val) {
				if (moment(val.dt2, 'DD/MM/YYYY').format('YYYY-MM-DD') < this.minDate) {
					this.customSwal.fire({
						icon: "error",
						title: "Gagal",
						text: `Tanggal tidak boleh lebih kecil dari ${moment(this.minDate, 'YYYY-MM-DD').format('DD MMM YYYY')}`,
						confirmButtonText: "OK"
					}).then(() => {
						this.filter.dt2 = moment(this.minDate, 'YYYY-MM-DD').format('DD/MM/YYYY');
						$(".datepicker").datepicker("update", this.filter.dt2);
						this.dataTable.api().ajax.reload();
					});
				} else if (moment(val.dt2, 'DD/MM/YYYY').format('YYYY-MM-DD') > moment().format('YYYY-MM-DD')) {
					this.customSwal.fire({
						icon: "error",
						title: "Gagal",
						text: `Tanggal tidak boleh lebih besar dari ${moment().format('DD MMM YYYY')}`,
						confirmButtonText: "OK"
					}).then(() => {
						this.filter.dt2 = moment().format('DD/MM/YYYY');
						$(".datepicker").datepicker("update", this.filter.dt2);
						this.dataTable.api().ajax.reload();
					});
				} else {
					this.dataTable.api().ajax.reload();
				}
			},
			deep: true
		}
	},
	mounted() {
		const e = this.$refs;
		var self = this;

		this.dataTable = createTable(e.tableRiwayatRekonsiliasi, {
			title: "",
			roles: this.$route.params.roles,
			ajax: "/report/hutang/monitoring",
			frame: false,
			toolbarEl: e.toolbar,
			fixedColumns: {
				start: 1,
				end: 1
			},
			scrollCollapse: true,
			scrollX: true,
			processing: true,
			autoWidth:false,
			language: {
				processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
			},
			filterBy: [0, 2],
			order: [],
			paramData: function (d) {
				var filter = JSON.parse(JSON.stringify(self.filter));
					filter.dt2 = moment(self.filter.dt2, 'DD/MM/YYYY').format('YYYY-MM-DD');
				for (const key in filter) {
					d[key] = filter[key] === false ? 0 : filter[key];
				}
			},
			columns: [
				{ data: "code" },
				{
					data: "tipe_rekan",
					render: function (data, type, row, meta) {
						if (self.showTipe[data]) {
							return self.showTipe[data];
						} else {
							return '';
						}
					}
				},
				{ data: "nama_rekan" },
				{
					data: "sisa_tagihan",
					render: function (data, type, row, meta) {
						return formatRupiah(data);
					}
				},
				{
					data: "id",
					sortable: false,
					render: function (data, type, row, meta) {
						return `<button class="btn btn-sm btn-outline-primary" data-action="show" data-id="${data}">Lihat Detail</button>`;
					}
				}
			],
			rowCallback: function (row, data) {
				if (data.sisa_tagihan < 0) {
					$("td:eq(3)", row).addClass("text-danger");
				}
				$("td:eq(4)", row).addClass("text-center");
			},
			initComplete: function () {
				$('.loading-overlay').removeClass('show');
			},
		});

		this.customSwal = Swal.mixin({
			customClass: {
				content: 'p-0',
				title: 'h4 tex-dark',
				input: 'form-control',
				actions: 'd-flex justify-content-between flex-row-reverse',
				confirmButton: 'btn btn-primary col font-weight-bold',
				denyButton: 'btn btn-outline-primary col font-weight-bold',
				cancelButton: 'btn btn-primary w-75 font-weight-bold m-auto',
			},
			buttonsStyling: false
		});
	},
};
</script>
<style type="text/css">
</style>